import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

// ─── Configure your UPI details here ──────────────────────────────────────────
const UPI_VPA    = 'yourname@upi';          // e.g. johndoe@oksbi
const PAYEE_NAME = 'TERAINFO';

// Standard UPI deep-link URI — tapping on mobile opens native UPI apps directly
const UPI_URI = `upi://pay?pa=${encodeURIComponent(UPI_VPA)}&pn=${encodeURIComponent(PAYEE_NAME)}&cu=INR`;

const UPI_APPS = ['Google Pay', 'PhonePe', 'Paytm', 'BHIM', 'Amazon Pay'];

export default function SupportPage() {
  return (
    <div className="max-w-lg mx-auto space-y-6">

      <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-8 text-center">
        <h3 className="text-xl font-bold text-gray-900 mb-1">Support Us</h3>
        <p className="text-gray-500 text-sm mb-6 max-w-sm mx-auto">
          If TERAINFO adds value to your daily routine, consider buying us a coffee.
          Every contribution helps keep the platform free and improving.
        </p>

        {/*
          The <a> wrapper encodes the UPI URI so tapping the QR on mobile
          opens the system UPI app chooser (deep-link trigger).
        */}
        <div className="flex justify-center mb-5">
          <a
            href={UPI_URI}
            title="Tap to pay via UPI"
            aria-label="Scan or tap to pay with UPI"
            className="block hover:opacity-90 active:scale-95 transition-transform cursor-pointer"
          >
            <div className="p-5 bg-gray-50 rounded-2xl border-2 border-gray-200 hover:border-indigo-300 transition-colors inline-block">
              <QRCodeSVG
                value={UPI_URI}
                size={192}
                bgColor="#f9fafb"
                fgColor="#1e293b"
                level="M"        /* Medium error correction for reliable scanning */
                includeMargin={false}
              />
            </div>
          </a>
        </div>

        <p className="text-gray-800 font-bold text-base">{PAYEE_NAME}</p>
        <p className="text-gray-400 font-mono text-sm mt-1 select-all">{UPI_VPA}</p>

        {/* Mobile hint */}
        <div className="mt-6 bg-amber-50 border border-amber-200 rounded-xl p-4 text-left">
          <p className="text-amber-800 font-semibold text-sm">📱 On mobile?</p>
          <p className="text-amber-700 text-sm mt-1">
            Tap the QR code above to open your UPI app directly without scanning.
          </p>
        </div>

        {/* Supported apps row */}
        <div className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-gray-400 text-xs">
          <span className="font-medium text-gray-500">Works with:</span>
          {UPI_APPS.map((app) => (
            <span key={app}>{app}</span>
          ))}
        </div>
      </div>

      {/* Thank-you note */}
      <div className="bg-indigo-50 border border-indigo-100 rounded-xl p-5 flex gap-4">
        <span className="text-2xl leading-none">🙏</span>
        <div>
          <p className="text-indigo-800 font-semibold text-sm">Thank you for your generosity</p>
          <p className="text-indigo-700 text-sm mt-0.5">
            All contributions go directly towards server costs, API subscriptions, and new features.
          </p>
        </div>
      </div>

    </div>
  );
}
